


  
  

  var faEmaerket = {
    prefix: 'fak',
    iconName: 'emaerket',
    icon: [
      655,
      512,
      [],
      'e000',
      
      'M86.9 185.4H12.4a7.2 7.2 0 0 1 -6.2-11C17.2 156.5 44 119.2 95 82l.1-.1c1.7-1.5 55.5-48.4 150.1-67.7c0 0 131.4-31 258.3 27.9c0 0 106.2 53 150.6 132.5a7.2 7.2 0 0 1 -6.3 10.7H616a28.8 28.8 0 0 1 -25-14.5c-9.3-16.4-30-44.9-72.2-75.2c0 0-76.3-56.4-196.1-44.5c0 0-68.3 5-124.6 40.3l-.1 .1c-1.6 .8-35.9 17.7-85.7 81.5A32 32 0 0 1 86.9 185.4zm485.9 29.4h74.5a7.2 7.2 0 0 1 6.2 11c-11 17.9-37.7 55.1-88.7 92.4a1.4 1.4 0 0 0 -.2 .1c-2.2 1.9-55.8 48.5-150.1 67.7c0 0-131.4 31-258.3-27.9c0 0-106.2-53-150.6-132.5a7.2 7.2 0 0 1 6.3-10.7H43.7a28.8 28.8 0 0 1 25 14.5c9.3 16.4 30 44.9 72.2 75.2c0 0 76.3 56.4 196.1 44.5c0 0 68.2-5 124.6-40.3l.2-.1c2-1 36.2-18.2 85.7-81.4a32 32 0 0 1 25.2-12.3zM405.3 231.6a25.6 25.6 0 0 0 -20.9 11c-5.9 8.5-16.6 19.8-33.6 25.2c0 0-41 14.8-71.2-19.7l155.2-69.7a13.1 13.1 0 0 0 6.7-16.4A117.9 117.9 0 0 0 327.4 86.3c-62.1 2.1-112.4 52.9-113.9 114.9a117.9 117.9 0 0 0 230.3 38.5 6.4 6.4 0 0 0 -6.2-8.3zM263.8 205a66.2 66.2 0 0 1 117.1-42.2l-116.3 52.5a66.7 66.7 0 0 1 -.8-10.2z'
      
    ]
  };

  



export {

  faEmaerket,
  

};
